import React, { useEffect, useState } from "react";
import { getCoreRowModel, useReactTable } from "@tanstack/react-table";
import useColumns from "./useColumns";
import { TabView, TabPanel } from "primereact/tabview";
import { DashboardListing } from "./properties-listing";
import { useLovedProperties } from "../../hooks/react-query/dashboard/useLovedProperties";
import { useYourBids } from "../../hooks/react-query/dashboard/useYourBids";
import { YourOffers } from "./your-bids";
import useColumnsYourOffers from "./useColumnYourBids";
import { useLocation, useNavigate } from "react-router-dom";
import MobileCardListing from "../common/mobile-dash-listing";
import { useRecentProperties } from "../../hooks/react-query/dashboard/useRecentProperties";
import { useRecentInfinite } from "../../hooks/react-query/dashboard/useRecentInfinite";
import { useInView } from "react-intersection-observer";
import { useYourBidInfinite } from "../../hooks/react-query/dashboard/useYourBidInfinite";
import { useSaveInfinite } from "../../hooks/react-query/dashboard/useSaveInfinite";
import { QueryClient } from "@tanstack/react-query";
import styles from "./recent-properties.module.scss";
import PropertyListCardSkeleton from "../../skeleton/card-skeleton";
import BeatLoaderC from "../common/DataLoader";
import { ToggleDashboardMenu } from "../investor/amplitude";
const DashboardProperty = ({ type }: { type: string }) => {
  let _recttotal = localStorage.getItem("RecentPropertyTotal") || "";
  let _rect = _recttotal?.replace(/"/g, "");

  const [totalCount, setTotalCount] = useState({
    recent: Number(_rect) ?? 100,
    bid: Number(localStorage.getItem("BidPropertyTotal")) ?? 100,
    saved: Number(localStorage.getItem("SavedPropertyTotal")) ?? 100
  });

  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const {
    data: arrLovedProperties,
    isLoading: savedLoading,
    isPlaceholderData: savedPlaceHolderData,
    refetch: savedRefetch
  } = useLovedProperties(type);
  const {
    data: arrYourOffers,
    isLoading: bidsLoading,
    isPlaceholderData: bidsPlaceHolderData,
    refetch: yourBidRefetch
  } = useYourBids(type);
  const {
    data: recentPropertyData,
    refetch: recentRefetch,
    isLoading: recetLoading,
    isPlaceholderData: recentPlaceHolderData
  } = useRecentProperties(type);

  const { ref, inView } = useInView();
  const { ref: ref1, inView: inView1 } = useInView();
  const { ref: ref2, inView: inView2 } = useInView();

  const recentInfinite = useRecentInfinite(type);
  const {
    data: recentPropertyInfiniteData,
    fetchNextPage,
    isFetchingNextPage: isFetchingNextPage,
    hasNextPage,
    refetch,
    isLoading
  }: any = recentInfinite;

  const yourBidInfinite = useYourBidInfinite(type);
  const {
    data: yourBidInfiniteData,
    fetchNextPage: fetchNextPage1,
    isFetchingNextPage: isFetchingNextPage1,
    hasNextPage: hasNextPage1,
    refetch: refetch1,
    isLoading: isLoading1
  }: any = yourBidInfinite;

  const saveInfinite = useSaveInfinite(type);
  const {
    data: saveInfiniteData,
    fetchNextPage: fetchNextPage2,
    isFetchingNextPage: isFetchingNextPage2,
    hasNextPage: hasNextPage2,
    refetch: refetch2,
    isLoading: isLoading2
  }: any = saveInfinite;

  const { recentPropertyColumns }: any = useColumns(type);
  const { OffersColumns }: any = useColumnsYourOffers(type);

  const table = useReactTable({
    data: recentPropertyData || [],
    columns: recentPropertyColumns,
    getCoreRowModel: getCoreRowModel()
  });

  const LovedPropertiesTable = useReactTable({
    data: arrLovedProperties || [],
    columns: recentPropertyColumns,
    getCoreRowModel: getCoreRowModel()
  });

  const YourOffersTable = useReactTable({
    data: arrYourOffers || [],
    columns: OffersColumns,
    getCoreRowModel: getCoreRowModel()
  });

  useEffect(() => {
    const recentCountFromLocalStorage = Number(
      localStorage.getItem("RecentPropertyTotal")
    );
    const bidCountFromLocalStorage = Number(
      localStorage.getItem("BidPropertyTotal")
    );
    const savedCountFromLocalStorage = Number(
      localStorage.getItem("SavedPropertyTotal")
    );

    const recentCount =
      recentPropertyData?.[0]?.full_count || recentCountFromLocalStorage || 0;
    const bidCount =
      arrYourOffers?.[0]?.full_count || bidCountFromLocalStorage || 0;
    const savedCount =
      arrLovedProperties?.[0]?.full_count || savedCountFromLocalStorage || 0;

    setTotalCount({
      recent: recentCount,
      bid: bidCount,
      saved: savedCount
    });
    // Store the full_count in local storage only for the first page, or if a new count is available
    if (Number(queryParams.get("page")) === 1) {
      if (recentPropertyData?.[0]?.full_count) {
        localStorage.setItem(
          "RecentPropertyTotal",
          recentPropertyData[0]?.full_count.replace(/"/g, "")
        );
      }
      if (arrYourOffers?.[0]?.full_count) {
        localStorage.setItem("BidPropertyTotal", arrYourOffers[0]?.full_count);
      }
      if (arrLovedProperties?.[0]?.full_count) {
        localStorage.setItem(
          "SavedPropertyTotal",
          arrLovedProperties[0]?.full_count
        );
      }
    }
  }, [recentPropertyData, arrYourOffers, arrLovedProperties]);

  useEffect(() => {
    // Trigger next page fetch if in view and there's more data to fetch
    if (inView && hasNextPage) {
      fetchNextPage();
    }
  }, [inView, hasNextPage, fetchNextPage]);

  useEffect(() => {
    // Trigger next page fetch if in view and there's more data to fetch
    if (inView1 && hasNextPage1) {
      fetchNextPage1();
    }
  }, [inView1, hasNextPage1, fetchNextPage1]);

  useEffect(() => {
    if (inView2 && hasNextPage2) {
      fetchNextPage2();
    }
  }, [inView2, hasNextPage2, fetchNextPage2]);

  // useEffect(() => {
  //   const handleResize = () => setIsMobile(window.innerWidth <= 768);
  //   window.addEventListener("resize", handleResize);
  //   return () => window.removeEventListener("resize", handleResize);
  // }, []);
  const queryClient = new QueryClient();
  const handleTabChange = async (e: { index: any }) => {
    const newParams = {
      panel: e.index.toString(), // Convert to string for URLSearchParams
      page: "1", // reset to page 1 on tab change
      limit: queryParams.get("limit") || 10
    };

    navigate(
      `${location.pathname}?panel=${newParams.panel}&page=1&limit=${newParams.limit}`
    );

    if (newParams.panel === "0") {
      recentRefetch();
      refetch();
      ToggleDashboardMenu("Recent Properties");
    } else if (newParams.panel === "1") {
      yourBidRefetch();
      refetch1();
    } else if (newParams.panel === "2") {
      savedRefetch();
      refetch2();
      ToggleDashboardMenu("Saved Properties");
      await queryClient.resetQueries({
        queryKey: ["Saved-Properties-infinite-list"]
      });
    }
  };
  const skeletonArray = new Array(10).fill({ id: 0 });

  return (
    <TabView
      className={styles.tabView}
      activeIndex={Number(queryParams.get("panel"))}
      onTabChange={handleTabChange}
    >
      <TabPanel header="Recent Properties">
        <>
          <DashboardListing
            type={type}
            recentPropertyData={recentPropertyData}
            table={table}
            totalRecords={totalCount.recent}
            objPropertyDetails={[]}
            refetch={recentRefetch}
            panelIndex={0}
            isLoading={recetLoading}
            isPlaceholderData={recentPlaceHolderData}
          />
          <>
            {isLoading ? (
              <div className={styles.propertyWrap}>
                {skeletonArray.map((_, index: any) => (
                  <PropertyListCardSkeleton key={index} />
                ))}
              </div>
            ) : (
              recentPropertyInfiniteData && (
                <>
                  <MobileCardListing
                    loginType={type}
                    recentPropertyData={recentPropertyInfiniteData}
                  />
                  {window.innerWidth < 1024 && (
                    <div
                      ref={ref}
                      style={{
                        height: "1px",
                        marginBottom: "115px",
                        marginTop: "15px"
                      }}
                    >
                      {isFetchingNextPage && <BeatLoaderC color="#272727" />}
                    </div>
                  )}
                </>
              )
            )}
          </>
        </>
      </TabPanel>
      <TabPanel
        header="Your Bids"
        headerClassName={`${type === "investor" ? styles.yourBidsHide : ""}`}
      >
        <>
          <YourOffers
            recentPropertyData={arrYourOffers}
            table={YourOffersTable}
            totalRecords={totalCount.bid}
            objPropertyDetails={[]}
            totalCount={totalCount.bid}
            panelIndex={1}
            isLoading={bidsLoading}
            isPlaceholderData={bidsPlaceHolderData}
          />
          <>
            {isLoading1 ? (
              <div className={styles.propertyWrap}>
                {skeletonArray.map((_, index: any) => (
                  <PropertyListCardSkeleton key={index} />
                ))}
              </div>
            ) : (
              yourBidInfiniteData && (
                <>
                  <MobileCardListing
                    type="bid"
                    loginType={type}
                    recentPropertyData={yourBidInfiniteData}
                  />
                  {window.innerWidth < 1024 && (
                    <div
                      ref={ref1}
                      style={{
                        height: "1px"
                      }}
                    >
                      {isFetchingNextPage1 && <BeatLoaderC color="#272727" />}
                      {/* <BeatLoaderC color="#272727" /> */}
                    </div>
                  )}
                </>
              )
            )}
          </>
        </>
      </TabPanel>

      <TabPanel header="Saved Properties">
        <>
          <DashboardListing
            type={type}
            recentPropertyData={arrLovedProperties}
            table={LovedPropertiesTable}
            totalRecords={totalCount.saved}
            objPropertyDetails={[]}
            refetch={recentRefetch}
            panelIndex={2}
            isLoading={savedLoading}
            isPlaceholderData={savedPlaceHolderData}
          />
          <>
            {isLoading2 ? (
              <div className={styles.propertyWrap}>
                {skeletonArray.map((_, index: any) => (
                  <PropertyListCardSkeleton key={index} />
                ))}
              </div>
            ) : (
              saveInfiniteData && (
                <>
                  <MobileCardListing
                    loginType={type}
                    recentPropertyData={saveInfiniteData}
                    type="saved"
                    refetch={refetch2}
                  />
                  {window.innerWidth < 1024 && (
                    <div
                      ref={ref2}
                      style={{
                        height: "1px",
                        marginBottom: "115px",
                        marginTop: "15px"
                      }}
                    >
                      {isFetchingNextPage2 && <BeatLoaderC color="#272727" />}
                    </div>
                  )}
                </>
              )
            )}
          </>
        </>
      </TabPanel>
    </TabView>
  );
};

export default React.memo(DashboardProperty);
